<svg viewBox="0 0 96 101">
    <g id="circle">
        <path d="m49,21c22.1,0 40,17.9 40,40s-17.9,40 -40,40s-40,-17.9 -40,-40s17.9,-40 40,-40z" />
    </g>
    <g id="mark">
        <rect
            stroke="null"
            height="33.220341"
            width="9.666667"
            y="37.889023"
            x="43.952381"
            stroke-opacity="null"
            stroke-width="null"
            fill="none"
        />
        <rect
            id="svg_3"
            height="7.796611"
            width="10.169492"
            y="78.373287"
            x="43.762717"
            stroke-opacity="null"
            stroke-width="null"
            stroke="null"
            fill="none"
        />
    </g>
</svg>
